export default __webpack_public_path__ + "static/media/eu_flag.6368f138.png";